import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Missing Supabase environment variables");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Tipos para o banco de dados
export interface Influencer {
  id: string;
  email: string;
  name: string;
  phone: string;
  social_media: string;
  followers_count: number;
  role: string;
  created_at: string;
  updated_at: string;
}

export interface Coupon {
  id: string;
  influencer_id: string;
  code: string;
  discount_percentage: number;
  is_active: boolean;
  created_at: string;
  expires_at?: string;
}

export interface Sale {
  id: string;
  coupon_id: string;
  customer_email: string;
  product_name: string;
  sale_amount: number;
  commission_amount: number;
  created_at: string;
}

export interface Commission {
  id: string;
  influencer_id: string;
  sale_id: string;
  amount: number;
  status: "pending" | "paid" | "cancelled";
  created_at: string;
  paid_at?: string;
}
